import type {
  AuthTokens,
  ChangePasswordInput,
  LoginResponse,
  MeResponse,
  SecurityOverview,
  TotpSetupResponse,
} from '@wave/shared';
import { api } from '../api/client';

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { email, password }, { skipAuth: true }),
  loginTotp: (mfaToken: string, code: string) =>
    api.post<AuthTokens>('/auth/login/totp', { mfaToken, code }, { skipAuth: true }),
  loginTelegram: (initData: string) =>
    api.post<AuthTokens>('/auth/telegram', { initData }, { skipAuth: true }),
  me: () => api.get<MeResponse>('/auth/me'),
  logout: (refreshToken: string) => api.post<{ ok: true }>('/auth/logout', { refreshToken }),

  // ─── безопасность аккаунта ───
  security: () => api.get<SecurityOverview>('/auth/security'),
  changePassword: (input: ChangePasswordInput) =>
    api.post<{ ok: true }>('/auth/password', input),
  totpSetup: () => api.post<TotpSetupResponse>('/auth/totp/setup'),
  totpConfirm: (code: string) => api.post<{ ok: true }>('/auth/totp/confirm', { code }),
  totpDisable: (password: string) =>
    api.delete<{ ok: true }>('/auth/totp', { password }),

  passkeyRegisterOptions: () =>
    api.post<{ options: Record<string, unknown>; challengeId: string }>(
      '/auth/passkey/register/options',
    ),
  passkeyRegisterVerify: (challengeId: string, credential: unknown, name: string) =>
    api.post<{ ok: true; id: string }>('/auth/passkey/register/verify', {
      challengeId,
      credential,
      name,
    }),
  passkeyLoginOptions: () =>
    api.post<{ options: Record<string, unknown>; challengeId: string }>(
      '/auth/passkey/login/options',
      undefined,
      { skipAuth: true },
    ),
  passkeyLoginVerify: (challengeId: string, credential: unknown) =>
    api.post<AuthTokens>(
      '/auth/passkey/login/verify',
      { challengeId, credential },
      { skipAuth: true },
    ),
  passkeyDelete: (id: string) => api.delete<{ ok: true }>(`/auth/passkey/${id}`),
};
